import type { ImageAnalyses } from '../../../@types/latestImagesV2';
import { analysesToAnalyzedImages } from '../../../react-query/useLatestImagesv2';

import { usePageContext } from './context/PageContext';
import { useImagePagination } from './hooks/useImagePagination';
import type { TSupportedTreatmentType } from './hooks/useSummary';
import type { TTreatmentDisplay } from './insuranceExport/InsuranceImages';
import { InsuranceImages } from './insuranceExport/InsuranceImages';
import { ImagesArea } from './insuranceExport/styles';
import { PaginationControl } from './PaginationControl';

export type ImagesViewProps = {
  images: ImageAnalyses[];
  dmfValues: { toothNumber: string; dmf: string }[];
  hidePMSInformation: boolean;
  estimatedVisitId: number;
  pmsAppointmentId?: string;
  selectedTreatments: TTreatmentDisplay[];
  supportedTreatmentType: TSupportedTreatmentType;
  imageFindingsResto: boolean;
  imageFindingsDmf: boolean;
  imageFindingsPerio: boolean;
  radiographsTakenDateFormatted: string;
  isPaginated: boolean;
  imageBw: boolean;
  narrativeText: string;
  imageFindingsEndo: boolean;
  imageSetGroup: string;
  clinicalNotes: string;
  patientName: string;
  dob: string;
  visitDate: string;
  includeRadiographsTakenDate: boolean;
};

export const ImagesView = ({
  images,
  dmfValues,
  hidePMSInformation,
  estimatedVisitId,
  pmsAppointmentId,
  selectedTreatments,
  supportedTreatmentType,
  imageFindingsResto,
  imageFindingsDmf,
  imageFindingsPerio,
  radiographsTakenDateFormatted,
  isPaginated,
  imageBw,
  narrativeText,
  imageFindingsEndo,
  imageSetGroup,
  clinicalNotes,
  patientName,
  dob,
  visitDate,
  includeRadiographsTakenDate,
}: ImagesViewProps) => {
  const { componentRef } = usePageContext();

  const { currentPage, pageCount, handlePageChange } =
    useImagePagination(images);

  return (
    <>
      {isPaginated && (
        <PaginationControl
          hasPagination={isPaginated}
          currentPage={currentPage}
          pages={pageCount}
          handleSetPage={handlePageChange}
        />
      )}
      <ImagesArea
        className="dialog-preview"
        ref={componentRef as React.RefObject<HTMLDivElement>}
      >
        <InsuranceImages
          images={analysesToAnalyzedImages(images)}
          imagesV2={images ?? []}
          dmfValues={dmfValues}
          hasPagination={isPaginated}
          currentPage={currentPage}
          hidePMSInformation={hidePMSInformation}
          isPaginated={isPaginated}
          estimatedVisitId={
            estimatedVisitId ? Number(estimatedVisitId) : undefined
          }
          pmsAppointmentId={pmsAppointmentId}
          insPage={'preview-single'}
          selectedTreatments={selectedTreatments}
          isSrp={supportedTreatmentType === 'SRP'}
          imageFindingsResto={imageFindingsResto}
          imageFindingsDmf={imageFindingsDmf}
          radiographsTakenDate={radiographsTakenDateFormatted}
          imageFindingsPerio={imageFindingsPerio}
          imageFindingsEndo={imageFindingsEndo}
          imageBw={imageBw}
          narrativeText={narrativeText}
          imageSetGroup={imageSetGroup}
          clinicalNotes={clinicalNotes}
          patientName={patientName}
          dob={dob}
          visitDate={visitDate}
          includeRadiographsTakenDate={includeRadiographsTakenDate}
        />
      </ImagesArea>
    </>
  );
};
